import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import FormPage from './components/FormPage';
import Cargos from './pages/Cargos';
import Escalas from './pages/Escalas';

const App = () => {
    return (
        <Router>
            <div className="min-h-screen flex flex-col bg-gray-50">
                <Navbar />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/form" element={<FormPage />} />
                        <Route path="/cargos" element={<Cargos />} />
                        <Route path="/escalas" element={<Escalas />} />
                    </Routes>
                </main>
                <footer className="bg-gray-800 text-white py-6">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <p className="text-center text-sm">© {new Date().getFullYear()} Generador DDJJ. Todos los derechos reservados.</p>
                    </div>
                </footer>
            </div>
        </Router>
    );
};

export default App;